import { Icons } from '@pankod/refine-antd'
import { ResourceProps } from '@pankod/refine-core'

import { AdminPendaftaranList } from '@resources/pendaftaran-diklat/admin-pendaftaran/list'
import { PengajuanPesertaDidikList } from '@resources/pendaftaran-diklat/pengajuan-peserta-didik/list'
import { PenyetujuanPesertaDidikList } from '@resources/pendaftaran-diklat/penyetujuan-peserta-didik/list'

export const diklatManagementResource: ResourceProps[] = [
  {
    name: 'pendaftaran-diklat',
    icon: <Icons.BookOutlined />,
    options: {
      label: 'Pendaftaran Diklat',
      route: 'pendaftaran-diklat',
    },
  },
  {
    name: 'admin-pendaftaran-management',
    parentName: 'pendaftaran-diklat',
    options: {
      label: 'Admin Pendaftaran',
      route: 'admin-pendaftaran-management',
    },
    list: AdminPendaftaranList,
  },
  {
    name: 'pengajuan-peserta-didik',
    parentName: 'pendaftaran-diklat',
    options: {
      label: 'Pengajuan Peserta Didik',
      route: 'pengajuan-peserta-didik',
    },
    list: PengajuanPesertaDidikList,
  },
  {
    name: 'penyetujuan-peserta-didik',
    parentName: 'pendaftaran-diklat',
    options: {
      label: 'Penyetujuan Peserta Didik',
      route: 'penyetujuan-peserta-didik',
    },
    list: PenyetujuanPesertaDidikList,
  },
]
